const state = {
    maintenanceInfoList: [],
    maintenanceList: [],
    selectedMaintenance: null,
    onderhoudsActivitiesLijst: [],
    onderhoudsTypesLijst: []
};

export default state;
